module.exports = __webpack_public_path__ + "static/media/isdoctorplan-oncology2@3x.c042f7b6.png";